<template>
  <div>
    <h2>{{ title }}</h2>
    <loading :active.sync="isLoading" :is-full-page="true"></loading>
    <template>
      <v-system-bar class="branch-data">
        <v-spacer></v-spacer>
        <div v-on:keypress.enter.prevent="getFreePageTable(1)">
          <input-search
            :model="search" @update="searchInput"/>
        </div>
        <circle-button
          v-if="permissionFreePage && permissionFreePage.permission_id === permission.readWrite"
          @click.native="createFreePage" />
      </v-system-bar>
    </template>
    <template>
      <v-simple-table class="branch-data">
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-center" v-for="header in headers" :key="header.id">
              {{ header.text }}
              <template v-if="header.icon">
                <a @click="sortDataTable">
                  <v-icon class="fas fa-caret-down"
                          v-if="sort == 'desc'"
                          style="font-size: 12px"></v-icon>
                  <v-icon class="fas fa-caret-up"
                          v-if="sort == 'asc'"
                          style="font-size: 12px"></v-icon>
                </a>
              </template>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(data, index) in dataTable" :key="data.id">
            <td align="center">{{((dataPaginate.current_page-1)*10)+(index+1)}}</td>
            <td>{{ data.title_en }}</td>
            <td>{{ data.slug_url }}</td>
            <td>{{ data.updated_at | moment("DD-MM-YYYY") }}</td>
            <td>
              <a @click="showFreePageData(data.id)">
                <icon-pencil />
              </a>
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
    <paginate :length="dataPaginate.last_page"
              :page="dataPaginate.current_page"
              @update="changePage">
    </paginate>

  </div>
</template>

<script>
  import InputSearch from "../../components/Input/InputSearch";
  import CircleButton from "../../components/Button/CircleButton";
  import IconPencil from "../../components/Icon/icon-pencil";
  import Paginate from "../../components/Layout/Paginate";
  import {permissionFreePage, role} from "../../util/Permission";
  import Loading from 'vue-loading-overlay';
  import Swal from 'sweetalert';
  export default {
    name: "FreePageTable",
    components: {Paginate, IconPencil, CircleButton, InputSearch, Loading },
    computed:{
      permissionFreePage
    },
    data() {
      return {
        title: "Free page",
        isLoading: false,
        headers: [
          { id: 1, text: "No.",icon : null },
          { id: 2, text: "Title" ,icon : null},
          { id: 3, text: "slug url" ,icon : null},
          { id: 4, text: "Update date" ,icon : true},
          { id: 5, text: "Edit" ,icon : null}
        ],
        dataTable: [],
        dataPaginate: {
          current_page: 1,
          from: 1,
          last_page: 1,
          per_page: 1,
          total: 1,
          to: 1
        },
        permission : null,
        search : '',
        sort : 'asc',
      };
    },
    created() {
      this.permission = role;
      this.getFreePageTable(1);
    },
    methods: {
      getFreePageTable(page) {
        this.isLoading = true;
        this.$store.dispatch("FreePage/getFreePage", {
          page,
          search : this.search,
          sort : this.sort,
        }).then(res => {
          if (res.response_code === 200) {
            this.dataTable = res.result.data;
            this.dataPaginate = {
              current_page: res.result.current_page,
              from: res.result.from,
              last_page: res.result.last_page,
              per_page: res.result.per_page,
              total: res.result.total,
              to: res.result.to
            }
          } else {
            Swal(res.response_msg);
          }
          this.isLoading = false;
        });
      },
      async changePage(val){
        this.isLoading = true;
        this.dataPaginate.current_page = val;
        await this.getFreePageTable(this.dataPaginate.current_page);
        this.isLoading = false;
      },
      goToFreePageEdit() {
        this.$router.push("/free-page/edit");
      },
      showFreePageData(id) {
        this.isLoading = true;
        this.$store.dispatch("FreePage/showFreePage", id).then(res => {
          if (res.response_code == 200) {
            this.$store.dispatch("FreePage/setFormFreePage", res.result).then(() => {
              this.goToFreePageEdit();
            });
          } else {
            Swal(res.response_msg);
          }
          this.isLoading = false;
        });
      },
      createFreePage() {
        this.$store.dispatch("FreePage/clearFormData").then(() => {
          this.goToFreePageEdit();
        });
      },
      searchInput(val){
        this.search = val;
      },
      sortDataTable(header_id){
        this.sort = this.sort == 'desc' ? 'asc' : 'desc';
        this.getFreePageTable(1);
      }
    }
  };
</script>

<style scoped>
  @import "../../assets/css/table.css";
  .branch-data {
    background-color: transparent;
    margin: 20px;
  }
</style>
